import { getIp } from "../Forms/Validations/IsIpAddressValidation";

export function compareIpList(v1?: string[], v2?: string[]): number {
    return compareIp(v1?.[0], v2?.[0])
}

export function compareIp(v1?: string, v2?: string): number {
    const ipString1 = v1?.split('/')[0];
    const ipString2 = v2?.split('/')[0];

    const ip1 = getIp(ipString1);
    const ip2 = getIp(ipString2);

    if(ip1 === undefined && ip2 === undefined) return 0;
    if(ip1 === undefined) return -1;
    if(ip2 === undefined) return 1;
    if(ip1.isEquals(ip2)) return 0;
    return ip1.isLessThan(ip2) ? -1 : 1;
}